import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { isEmpty } from "lodash";
import { Col, Container, Row } from "reactstrap";
import { Card, CardBody } from "reactstrap";
import GoogleMapReact from "google-map-react";
import "bootstrap-icons/font/bootstrap-icons.css";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import { getLabDetail } from "store/viewlabs/actions";

class LabDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    console.log(this.props.lab.Logo);
    const defaultProps = {
      center: {
        lat: this.props.lab.latitude,
        lng: this.props.lab.longitude,
      },
      zoom: 11,
    };
    const AnyReactComponent = ({ text }) => (
      <div>
        <i className="bi bi-geo-alt-fill fa-4x" style={{ color: "red" }}></i>
      </div>
    );

    return (
      <Row>
        <Col lg="7">
          <Card>
            <CardBody>
              <div>
                <div className="flex-grow-1 overflow-hidden">
                  <h5 className="text-truncate font-size-24">
                    <img
                      src={this.props.lab.Logo}
                      style={{ width: 100, height: 100, margin: 3, radius: 3 }}
                    />
                    {this.props.lab.name}
                  </h5>

                  <hr
                    style={{
                      background: "black",
                      color: "black",
                      borderColor: "black",
                      height: "3px",
                    }}
                  />
                  <h3 className="text-muted font-size-10">
                    {" "}
                    {this.props.lab.email}
                  </h3>
                </div>
                <h5 className="font-size-15 mt-4">Lab Address :</h5>
                <p className="text-muted">{this.props.lab.address}</p>
                <h5 className="font-size-15 mt-4">Landline :</h5>
                <p className="text-muted">{this.props.lab.landline_number}</p>
                <h5 className="font-size-15 mt-4">Contact :</h5>
                <p className="text-muted">{this.props.lab.contact_number}</p>
                <h5 className="font-size-15 mt-4">Health Department ID :</h5>
                <p className="text-muted">
                  {this.props.lab.health_department_id}
                </p>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col lg="5">
          <Card>
            <CardBody>
              <div className="d-flex flex-wrap">
                <Col>
                  <h5 className="font-size-17 ">Location:</h5>
                  <div style={{ height: "48vh", width: "100%" }}>
                    <GoogleMapReact
                      bootstrapURLKeys={{
                        key: "AIzaSyByM7-j7oFt6VMNHIL7NGmByptWJt_2cfI",
                      }}
                      defaultCenter={defaultProps.center}
                      defaultZoom={defaultProps.zoom}
                    >
                      <AnyReactComponent
                        lat={this.props.lab.latitude}
                        lng={this.props.lab.longitude}
                        text="My Marker"
                      />
                    </GoogleMapReact>
                  </div>
                </Col>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }
}

LabDetails.propTypes = {
  lab: PropTypes.object,
};

export default LabDetails;
